import React from 'react'

import { BodyScrollLock } from 'components/styled'
import {
  ModalBox,
  ModalBody,
  ModalContent,
  ModalBackdrop,
  ModalFooter,
  CancelButton,
  ConfirmButton
} from './styles'

const ProfessionalInfoModal = ({
  visible,
  fullButton = true,
  children,
  onCancel,
  outlineCancelButton,
  onConfirm,
  type = 'info', // info, action or warning
  cancelLabel,
  confirmLabel = 'Confirmar',
  dataTest,
  modalHeight,
  modalWidth,
  contentWidth
}) => {
  return (
    <>
      <ModalBackdrop visible={visible} onClick={onCancel} data-test={`${dataTest}-backdrop`} />
      <ModalBox visible={visible} type={type} data-test={dataTest} modalHeight={modalHeight} modalWidth={modalWidth}>

        <ModalBody contentWidth={contentWidth} type={type}>
          <ModalContent data-test={`${dataTest}-content`} type={type}>{children}</ModalContent>
        </ModalBody>
        <ModalFooter contentWidth={contentWidth}>
          {(onCancel && cancelLabel) && <CancelButton outlineCancelButton={outlineCancelButton} fullButton={fullButton} data-test={`${dataTest}-button-cancel`} onClick={onCancel}>{cancelLabel}</CancelButton>}
          {(onConfirm && confirmLabel) && <ConfirmButton fullButton={fullButton} data-test={`${dataTest}-button-confirm`} onClick={onConfirm}>{confirmLabel}</ConfirmButton>}
        </ModalFooter>
      </ModalBox>
      <BodyScrollLock active={visible} />
    </>
  )
}

export default ProfessionalInfoModal
